import {http} from '@/helpers/http-helper';

class Agreement {
    constructor(
        uuid,
        name,
        entity,
        description,
        type,
        feeAmount,
        startDate,
        endDate,
        validPeriod,
        headquarters
    ) {
        this.uuid = uuid;
        this.name = name;
        this.entity = entity;
        this.description = description;
        this.type = type;
        this.feeAmount = feeAmount;
        this.startDate = startDate;
        this.endDate = endDate;
        this.validPeriod = validPeriod;
        this.headquarters = headquarters;
    }
}

export const getAgreements = () => {
    return new Promise((resolve, reject) => {
        const url = 'agreements';
        http.get(url)
            .then((response) => {
                if (response.status === 200) {
                    let agreements = [];
                    response.data.forEach((agreement) => {
                        agreements.push(new Agreement(
                            agreement.uuid,
                            agreement.name,
                            agreement.entity,
                            agreement.description,
                            agreement.type,
                            agreement.feeAmount,
                            new Date(agreement.start_date),
                            new Date(agreement.end_date),
                            agreement.valid_period,
                            agreement.headquarters
                        ));
                    });

                    resolve(agreements);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};